import { WMICLogger, JobType, LINE_OF_BUSINESS } from 'wmic-pe-portals-utils-js';
import { LoadSaveService } from 'wmic-pe-capability-gateway-quoteandbind';
import { GatewayEndorsementService } from 'wmic-pe-capability-gateway-policychange';
import { GatewayRenewalService } from 'wmic-pe-capability-gateway-policyrenewal';
import _ from 'lodash';

const getSaveAndRecalculateFlexByJobType = flexOrBrokerModalVM => {
    const jobType = _.get(flexOrBrokerModalVM, 'baseData.jobType.value.code');
    let saveAndRecalculate;
    let quoteID;

    switch (jobType) {
        case JobType.SUBMISSION:
            saveAndRecalculate = LoadSaveService.saveAndRecalculateFlexForSubmission;
            quoteID = _.get(flexOrBrokerModalVM, 'quoteID.value');
            break;
        case JobType.POLICY_CHANGE:
            saveAndRecalculate = GatewayEndorsementService.saveAndRecalculateFlexForPolicyChange;
            quoteID = _.get(flexOrBrokerModalVM, 'jobID.value');
            break;
        case JobType.RENEWAL:
            saveAndRecalculate = GatewayRenewalService.saveAndRecalculateFlexForRenewal;
            quoteID = _.get(flexOrBrokerModalVM, 'jobID.value');
            break;
        default:
            break;
    }

    if (!saveAndRecalculate || !quoteID) {
        WMICLogger.error('Error in Flex handleRecalc', 'No saveAndRecalculate or quoteID');
        return;
    }

    return {
        saveAndRecalculate,
        quoteID,
    };
};

const hasInvalidFlexFields = (vm) => {
    let risks = [];
    const lob = vm?.lob?.value?.code;
    switch (lob) {
        case LINE_OF_BUSINESS.PERSONAL_AUTO:
            risks = vm?.lobData?.personalAuto?.coverables?.vehicles?.children || [];
            break;
        case LINE_OF_BUSINESS.HOME_OWNER:
            risks = vm?.lobData?.homeowners?.coverables?.dwellings?.children || [];
            break;
        default:
            risks = [];
    }

    return risks.some(risk => {
        const flexDTO = risk?.flexDTO;
        if (!flexDTO || !flexDTO?.isFlexEditable?.value) {
            return false;
        }

        // Guard: if subtree is valid, no issues
        if (flexDTO.aspects?.subtreeValid !== false) {
            return false;
        }

        // Check to see if the only invalid subtree is flexDollarAmount, then check if its a floating point error, if so, do our own validation check.
        const flexDollarAmountOnly = flexDTO.flexDollarAmount?.aspects?.subtreeValid === false
            && flexDTO.flexDollarAmount?.aspects?.valid !== false
            && flexDTO.flexPercentage?.aspects?.valid !== false;

        if (flexDollarAmountOnly) {
            // Verify with our own rounded comparison to confirm it's truly a false positive
            const flexAmount = flexDTO.flexDollarAmount?.value?.amount;
            const maxFlexAllowance = flexDTO.maxFlexAllowance?.value;
            const isActuallyExceeded = flexAmount != null && maxFlexAllowance != null
                && flexAmount < 0 && _.round(flexAmount, 2) < _.round(maxFlexAllowance, 2);

            return isActuallyExceeded;
        }

        return true;
    });
};

const mergeRequoteResponseIntoVM = (jobVM, response, viewModelService) => {
    const newJobVM = viewModelService.clone(jobVM);
    Object.assign(newJobVM.value, response);
    return newJobVM;
};

export default {
    getSaveAndRecalculateFlexByJobType,
    hasInvalidFlexFields,
    mergeRequoteResponseIntoVM,
};